import { sendRequest } from "@/shared/api/requestSender";
import { API_URL } from "@/shared/api/apiUrl";
import { HttpMethod, INonInventory } from '@/shared/types';

import { IGetManyNonInventoryParams } from "../model/types/interfaces";

export const sendGetNonInventoryRequest = (requestId: number) =>
  sendRequest({
    path: `${API_URL.nonInventory.getOne}/${requestId}`,
    method: HttpMethod.GET,
  });

export const sendUpdateNonInventoryRequest = (
  requestId: number,
  body: Partial<INonInventory> | unknown
) =>
  sendRequest({
    path: `${API_URL.nonInventory.updateOne}/${requestId}`,
    method: HttpMethod.PATCH,
    data: body,
  });

export const sendCreateNonInventoryRequest = (
  message: string,
  id?: number
) =>
  sendRequest({
    path: API_URL.nonInventory.createOne,
    method: HttpMethod.POST,
    data: {
      name: id != null ? `loinc_code:${id}` : '',
      message,
    },
  });

export const sendDeleteNonInventoryRequest = (requestId: number) =>
  sendRequest({
    path: `${API_URL.nonInventory.deleteOne}/${requestId}`,
    method: HttpMethod.DELETE,
  });

export const sendGetManyNonInventoryRequest = (body: IGetManyNonInventoryParams) =>
  sendRequest({
    path: API_URL.nonInventory.getMany,
    method: HttpMethod.POST,
    data: body,
  });
